import CompoundingYieldIcon from '~/@mid_ui/icons/CompoundingYieldIcon'

export function FeeImmunityTooltipContent(
  yieldRangeText?: string,
  isYieldCompoundingAnnually?: boolean
) {
  const yieldSuffix = isYieldCompoundingAnnually ? (
    <CompoundingYieldIcon
      size={16}
      percentColor="#000"
      arrowColor="#000"
      className="inline-block align-middle"
    />
  ) : (
    '%'
  )

  return (
    <p className="text-[13px] font-semibold text-primary leading-normal text-wrap">
      Kým ostatní platia poplatky, vy nie.
      <br />
      {yieldRangeText ? (
        <>
          Celý výnos {yieldRangeText} {yieldSuffix} p.a. je váš.
        </>
      ) : (
        'Celý výnos je váš.'
      )}
    </p>
  )
}
